import { render } from "./ServersComponent.vue?vue&type=template&id=70196d68&scoped=true"
const script = {}

import "./ServersComponent.vue?vue&type=style&index=0&id=70196d68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70196d68"]])

export default __exports__